import React, { useRef, useState } from "react";
import Input from "./Input";
import { db, uploadFile } from "../../FirebaseConfig.ts";
import { addDoc, collection, getDocs, query, where } from "firebase/firestore";
import Spinner from "../../components/Spinner";
import { useSnapshot } from "../../hooks/useSnapshot.js";
import useUpdateDoc from "../../hooks/useUpdateDoc.js";
import dayjs from "dayjs";

function FormStepTwo({
  setActiveMoney,
  activeMoney,
  setStep,
  data,
  setData,
  files,
  setFiles,
  sended,
  setSended,
  admin,
}) {
  const form = useRef();

  const [loading, setLoading] = useState(false);
  const [selectedCompany, setSelectedCompany] = useState("");
  const [error, setError] = useState("");

  const hostname = window.location.hostname;

  const { handleUpdate } = useUpdateDoc();

  const { data: tasa, isFetching } = useSnapshot("tasa");

  const sendCredit = async (e) => {
    e.preventDefault();

    setLoading(true);
    //sube el archivo a firebase

    const name = `${data.name} ${data.lastName}`;

    try {
      const uploadPromises = Object.keys(files).map(async (key) => {
        const file = files[key];

        if (file) {
          // Solo subimos si el archivo está presente
          const url = await uploadFile(file, `${name}/${key}`);
          return { [key]: url }; // Retornamos un objeto con el nombre del archivo como clave
        }
        return null;
      });

      const uploadResults = await Promise.all(uploadPromises);

      // Convertir los resultados en un objeto de URLs
      const fileUrls = uploadResults.reduce((acc, curr) => {
        if (curr) {
          return { ...acc, ...curr };
        }
        return acc;
      }, {});

      const res = await addDoc(collection(db, "requests"), {
        ...data,
        ...fileUrls,
        status: "pendiente",
        numberCredit: dayjs().format("YYYYMMDDmms"),
        codeudor: "",
        tasa: tasa[0].number,
        start_date: "",
        companyId: selectedCompany,
        ammount: data.ammount.replace(/\./g, ""),
        majorCompanyId:
          hostname === "creditos.sofia.com.co"
            ? "tPxAubnMGdjLnSRk2njL"
            : "tR4wlhMSbqlarCewjq5m",
      });

      handleUpdate("requests", res.id, { uuid: res.id });

      if (hostname !== "creditos.sofia.com.co") {
        const response = await fetch(
          "https://www.lendy.com.co/api/send-email",
          {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({
              to: "christian@grupogemcorp.com",
              subject: "Nueva Solicitud Lendy",
              message: "Hola, tienes una nueva solicitud en Lendy",
            }),
          }
        );
      }

      setFiles({
        cert_laboral: "",
        comp_nomina: "",
        fot_cedula: "",
        dec_renta: "",
      });
      setError("");
      setSended(true);
    } catch (error) {
      console.log("error", error);
      setLoading(false);
      setError(
        "Ha ocurrido un error al mandar la solicitud, por favor intente nuevamente"
      );
      setSended(false);
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      {/* <button
        className="text-white bg-primary"
        onClick={() => handleSubmitEmail()}
      >
        Enviar Email
      </button> */}
      <button
        onClick={() => {
          setStep(0);
          setActiveMoney(activeMoney);
        }}
      >
        <svg
          width="20px"
          height="20px"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M20 12H4M4 12L10 6M4 12L10 18"
            stroke="#000000"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      </button>
      <form className="w-full mx-auto" ref={form} onSubmit={sendCredit}>
        <div className="grid grid-cols-1 md:grid-cols-2 md:gap-5">
          <Input
            black
            label="Nombres"
            onChange={(e) => {
              setData({ ...data, name: e.target.value });
            }}
            value={data.name}
          />
          <Input
            black
            label="Apellidos"
            onChange={(e) => {
              setData({ ...data, lastName: e.target.value });
            }}
            value={data.lastName}
          />
        </div>
        <div className="grid grid-cols-1 md:gap-5">
          <Input
            black
            label="Correo"
            onChange={(e) => {
              setData({ ...data, email: e.target.value });
            }}
            value={data.email}
          />
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 md:gap-5">
          <Input
            black
            label="Dirección"
            onChange={(e) => {
              setData({ ...data, address: e.target.value });
            }}
            value={data.address}
            admin={admin}
          />
          <Input
            black
            label="Teléfono"
            onChange={(e) => {
              setData({ ...data, cellphone: e.target.value });
            }}
            value={data.cellphone}
            admin={admin}
          />
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 md:gap-5">
          <Input
            black
            label="Cédula"
            onChange={(e) => {
              setData({ ...data, identity: e.target.value });
            }}
            value={data.identity}
          />

          <Input
            black
            label="Lugar de Expedición"
            onChange={(e) => {
              setData({ ...data, expedition: e.target.value });
            }}
            value={data.expedition}
          />
        </div>

        <div className="mb-2 mt-1">
          <label
            htmlFor="empresa"
            className={`block mb-2 text-md font-medium `}
          >
            Empresa
          </label>
          <select
            onChange={(e) => setSelectedCompany(e.target.value)}
            id="empresa"
            className={`bg-robin bg-opacity-20  text-sm rounded-lg block w-full p-2.5 focus:outline-none focus:ring-2 focus:ring-blue-500`}
          >
            <option value="z48hZdY8K6AyB8n2jgi2">Pat Bpo SAS</option>
            <option value="9zVvLKu6yW5eM3l8dHQd">Gemcorp SAS</option>
          </select>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 md:gap-5">
          <Input
            black
            label="Certificación Laboral"
            type="file"
            onChange={(e) => {
              setFiles({ ...files, cert_laboral: e.target.files[0] });
            }}
            accept="application/pdf,application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document"
            admin={admin}
          />
          <Input
            black
            label="Comprobante de nómina"
            type="file"
            onChange={(e) => {
              setFiles({ ...files, comp_nomina: e.target.files[0] });
            }}
            accept="application/pdf,application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document"
            admin={admin}
          />
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 md:gap-5">
          <Input
            black
            label="Fotocopia de la cédula"
            type="file"
            onChange={(e) => {
              setFiles({ ...files, fot_cedula: e.target.files[0] });
            }}
            accept="application/pdf,application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document"
            admin={admin}
          />
          <Input
            black
            label="Declaración de renta"
            type="file"
            onChange={(e) => {
              setFiles({ ...files, dec_renta: e.target.files[0] });
            }}
            accept="application/pdf,application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document"
            admin={admin}
            subtitle={
              <>
                <p className="text-xs text-black">
                  ¿No declaras renta?{" "}
                  <a
                    href="https://firebasestorage.googleapis.com/v0/b/lendy-b18c6.firebasestorage.app/o/Certificado%20No%20declarante%201.docx?alt=media&token=40994dce-ab95-47dc-9f63-4a78582e3e1f"
                    className="text-primary"
                    target="_blank"
                    rel="noreferrer"
                  >
                    descarga el formato de no declarante
                  </a>
                </p>
              </>
            }
          />
        </div>

        {admin ? (
          ""
        ) : (
          <div className="flex items-center justify-center py-3">
            <input
              black
              id="link-checkbox"
              type="checkbox"
              value=""
              className="w-4 h-4 text-blue-600 bg-gray-100 border-gray-300 rounded focus:ring-blue-500"
              required
            />
            <label
              htmlFor="link-checkbox"
              className="ms-2 text-sm font-medium text-black"
            >
              Estoy de acuerdo con los{" "}
              <a href="#" className="text-primary hover:underline">
                términos y condiciones
              </a>
            </label>
          </div>
        )}

        {error && <p className="text-primary">{error}</p>}
        {sended && (
          <p className="text-green-400 mb-3">Solicitud enviada correctamente</p>
        )}
        <button
          type="submit"
          className={`text-white rounded-lg px-5 py-2.5 text-center ${
            hostname === "creditos.sofia.com.co" ? "bg-primary" : "bg-black"
          } w-full font-bold text-xl`}
          disabled={loading}
        >
          {loading ? <Spinner /> : "Solicitud de crédito"}
        </button>
      </form>
    </>
  );
}

export default FormStepTwo;
